var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlane = function SvgPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 90 63"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#plane_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.445 6.522q39.048-3.25 78.101-6.5c5.202-.432 8.397 5.479 5.125 9.485l-41.82 51.225c-2.23 2.733-6.385 2.93-8.87.423q-2.893-2.917-5.788-5.826c-1.964-1.977-5.065-2.328-7.43-.846q-3.21 2.014-6.42 4.02c-4.215 2.639-9.656-.714-9.084-5.6.717-6.167 1.44-12.338 2.157-18.505a5.76 5.76 0 0 0-.863-3.763L.905 15.439c-2.353-3.707.111-8.554 4.536-8.922z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.39 26.808 13.701 53.6c22.947-16.088 45.89-32.172 68.834-48.26C61.488 12.497 40.44 19.65 19.39 26.809"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.811,
    d: "M18.553 29.294C14.414 24.036 10.28 18.779 6.14 13.522c-.785-1-.145-2.473 1.128-2.58L85.063 4.65c-22.17 8.213-44.34 16.43-66.506 24.643z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.811,
    d: "M25.083 37.011c5.134 6.321 10.263 12.646 15.397 18.967a1.597 1.597 0 0 0 2.472.009C56.986 38.873 71.025 21.76 85.06 4.65L25.083 37.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.553 29.294c-1.615 8.102-3.234 16.204-4.848 24.306 3.793-5.531 7.585-11.058 11.382-16.589l4.706 5.8C24.433 46.407 19.07 50.003 13.71 53.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.811,
    d: "M18.553 29.294c-1.615 8.102-3.234 16.204-4.848 24.306 3.793-5.531 7.585-11.058 11.382-16.589l4.706 5.8C24.433 46.407 19.07 50.003 13.71 53.6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "plane_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h90v62.918H0z"
  })))));
};
export default SvgPlane;